import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05194ea4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2623.2606277501854!2d9.190645076969163!3d48.891369971336545!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4799d1b8bb06ad15%3A0x5ec5b253f9b7de0f!2sHangover%20Shisha%20Bar%20Lounge!5e0!3m2!1sde!2sde!4v1686943881667!5m2!1sde!2sde",
  width: "100%",
  height: "550",
  allowfullscreen: "",
  loading: "lazy",
  referrerpolicy: "no-referrer-when-downgrade"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_card_actions, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "outlined",
          "prepend-icon": "mdi-map",
          href: _ctx.openNativeMaps()
        }, {
          default: _withCtx(() => [
            _createTextVNode("In Maps öffnen")
          ]),
          _: 1
        }, 8, ["href"])
      ]),
      _: 1
    })
  ]))
}